import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ActivationHelper } from '../activation/activation.helper'

// Service
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'onlytv-activation',
  templateUrl: 'activation.component.html',
  styleUrls: ['./activation.component.scss']
})
export class ActivationComponent implements OnInit {
  message1!: string;
  message2!: string;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.checkAndBox();
  }

  public checkAndBox() {
    if (this.authService.isBox()) {
      this.authService.infoBox();
      if (localStorage.getItem('AccessToken')) {
        this.payingsubscriber();
      } else {
        this.router.navigate(['/promo']);
      }
    } else {
        //TODO: quanto ativar o modo de produção remover esta linha
        // this.router.navigate(['/home']);
        this.message1 = 'Seu dispositivo não é compativel com esta versão';
        // this.message2 = navigator.userAgent
    }
  }


  public payingsubscriber() {
    // email e password fixo para pegar o token TODO: definir como usar o QR code
    const getAccess: any = localStorage.getItem('access')
    if(getAccess){
      this.authService.sign(JSON.parse(getAccess)).subscribe({
        next: (res) => res,
        error: (e) => e,
      })
    }else{
      this.router.navigate(['/promo'])
    }
  }
}
